var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fetching__overlay"},[_c('Spinner',{style:({ fontSize: '2rem' }),attrs:{"theme":_vm.primary}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }